import app from '../app'


app.component('app-top-navigation-bar', require('./Components/Layout/TopBar').default)

//Support
app.component('modal', require('./Components/Helper/Modal').default)
app.component('app-page-top-section', require('./Components/Helper/PageTopSection').default)
app.component('app-default-button', require('./Components/Helper/Button/DefaultButton').default)
app.component('app-submit-button', require('./Components/Helper/Button/SubmitButton').default)
app.component('app-cancel-button', require('./Components/Helper/Button/CancelButton').default)
app.component('app-context-button', require('./Components/Helper/Button/ContextButton').default)
app.component('app-message', require('./Components/Helper/Message/Message').default)
app.component('app-form-group', require('./Components/Helper/FormGroup').default)
app.component('app-custom-field-builder', require('./Components/Helper/CustomFieldBuilder').default)
app.component('app-list-dropdown', require('./Components/Helper/ListDropdown').default)
app.component('app-custom-notification-dropdown', require('./Components/Layout/Notification/AppNotificationDropdown').default)

//Users
app.component('app-users-roles', require('./Components/UserRole/Index').default);
app.component('app-roles-modal', require('./Components/UserRole/UI/RolesModal').default);
app.component('app-user-modal', require('./Components/UserRole/UI/UserModal').default);
app.component('image-group', require('./Components/UserRole/UI/ImageGroup').default);
app.component('app-user-invite-modal', require('./Components/UserRole/UI/UserInviteModal').default);
app.component('app-user-invite-confirm', require('./Components/Auth/UserInvitationConfirm').default)
app.component('app-user-media', require('./Components/UserRole/UI/UserMedia').default)
app.component('app-notifications', require('./Components/Auth/Notifications').default);

//Profile
app.component('app-user-profile', require('./Components/Auth/Profile').default)
app.component('app-profile-personal-info', require('./Components/Auth/Profile/ProfilePersonalInfo').default);
app.component('app-password-change', require('./Components/Auth/Profile/PasswordChange').default)
app.component('app-activity', require('./Components/Auth/Profile/Activity').default)

//Settings
app.component('app-settings-layout', require('./Components/Settings/Global/App/SettingLayout').default);
app.component('app-general-settings', require('./Components/Settings/Global/App/Component/GeneralSetting').default)
app.component('app-delivery-settings', require('./Components/Settings/Common/DeliverySettings').default)
app.component('app-test-mail-modal', require('./Components/Settings/Common/Delivery/TestMailModal').default)
app.component('app-mailgun', require('./Components/Settings/Common/Delivery/Mailgun').default)
app.component('app-ses', require('./Components/Settings/Common/Delivery/SES').default)
app.component('app-smtp', require('./Components/Settings/Common/Delivery/SMTP').default)
app.component('app-mandrill', require('./Components/Settings/Common/Delivery/Mandrill').default)
app.component('app-postmark', require('./Components/Settings/Common/Delivery/Postmark').default)
app.component('app-sparkpost', require('./Components/Settings/Common/Delivery/Sparkpost').default)
app.component('app-sendmail', require('./Components/Settings/Common/Delivery/Sendmail').default)
app.component('app-notification-settings', require('./Components/Settings/Common/NotificationSettings').default)
app.component('app-update-notification-settings', require('./Components/Settings/Common/http/StoreUpdateNotificationSettings').default)
app.component('app-update-notification-templates', require('./Components/Settings/Common/http/StoreUpdateNotificationTemplate').default)
app.component('app-mail-template', require('./Components/Settings/Common/http/NotificationTemplate/MailTemplate').default)
app.component('app-database-template', require('./Components/Settings/Common/http/NotificationTemplate/DatabaseTemplate').default)

//Tenant settings
app.component('tenant-settings-layout', require('./Components/Settings/Global/Tenant/TenantSettingLayout').default);
app.component('tenant-custom-field-settings', require('./Components/Settings/Global/Tenant/Component/CustomField/CustomFields').default);
app.component('tenant-store-update-custom-fields', require('./Components/Settings/Global/Tenant/Component/CustomField/StoreUpdateCustomFields').default);

//Authentication
app.component('app-auth-login', require('./Components/Auth/Login').default);

